module.exports = __webpack_public_path__ + "img/fig_2.df0dbd2f.svg";